import { useMemo, useState, useCallback } from "react";
import dayjs from "dayjs";
import {
  calculateTimeRange,
  formatToISO,
  getCustomDateRange,
} from "../components/chart/utils";

export const useTimeRange = (initialButton = "24h") => {
  const [selectedButton, setSelectedButton] = useState(initialButton);
  const [customDateRange, setCustomDateRange] = useState([]);
  const isTimeRangeReady =
    selectedButton !== "custom" || customDateRange.length === 2;

  const timeRange = useMemo(() => {
    const now = dayjs().utc();

    if (selectedButton === "custom") {
      if (customDateRange.length < 2) {
        return { from: "", to: "" };
      }

      const { from, to } = getCustomDateRange(customDateRange);
      return {
        from: formatToISO(from),
        to: formatToISO(to),
      };
    }

    return {
      from: formatToISO(calculateTimeRange(selectedButton, now)),
      to: formatToISO(now),
    };
  }, [selectedButton, customDateRange]);

  const handleButtonClick = useCallback((buttonValue) => {
    setSelectedButton(buttonValue);
  }, []);

  const handleDateRangeChange = useCallback((dates) => {
    setCustomDateRange(dates);
  }, []);

  return {
    selectedButton,
    timeRange,
    customDateRange,
    isTimeRangeReady,
    handleButtonClick,
    handleDateRangeChange,
  };
};
